import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import firebase from "firebase/app";
import firebaseConfig from "./firebase.config";
import { Container, Row, Col, Button } from "reactstrap";
import "firebase/auth";
import "firebase/firestore";
import { UserContext } from "../../App";

if (firebase.apps.length === 0) {
  firebase.initializeApp(firebaseConfig);
} else {
  firebase.app();
}

var provider = new firebase.auth.GoogleAuthProvider();

const Login = () => {
  const { userData, setUserData } = useContext(UserContext);
  const [logErrors, setLogErrors] = useState({});
  const [isSignUp, setSignUp] = useState(false);

  //google sign In
  const googleSignInHandle = () => {
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        var user = result.user;
        userData.name = user.displayName;
        userData.email = user.email;
        userData.photo = user.photoURL;
        console.log(userData);
        console.log(user.displayName, user.email, user.photoURL);
      })
      .catch((error) => {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        setLogErrors(...errorCode, ...errorMessage, ...email, ...credential);
        console.log(errorCode, errorMessage, email, credential);
      });
  };
  const { register, handleSubmit, errors } = useForm();
  const onSubmit = (data) => {
    const fullName = data.firstName + data.lastName;
    if (data.password1 === data.password2) {
      userData.password = data.password1;
    }
    userData.logInPassword = data.password1;
    if (data.email) {
      userData.email = data.email;
    }
    userData.name = fullName;
    console.log(data);
  };
  //sign in and sign up form
  const hadleSignInAndSignUp = () => {
    //
    //sign Up section
    if (userData.email && userData.password) {
      firebase
        .auth()
        .createUserWithEmailAndPassword(userData.email, userData.password)
        .then((res) => {
          console.log(res);
          const signUpData = res.user;
          console.log(signUpData);
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          setLogErrors(...errorCode, ...errorMessage);
          console.log(errorCode, errorMessage);
        });

      //
      //sign In section
      firebase
        .auth()
        .signInWithEmailAndPassword(userData.email, userData.logInPassword)
        .then((res) => {
          const signInData = res.user;
          console.log(signInData.email);
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log(errorCode, errorMessage);
          setLogErrors(...errorCode, ...errorMessage);
        });
    }
    console.log(logErrors);
  };

  return (
    <Container className="text-start my-5">
      <Row>
        <Col md={{ size: 6, offset: 3 }}>
          <form onSubmit={handleSubmit(onSubmit)}>
            {isSignUp && (
              <div className="form-group">
                <label htmlFor="Name">First name</label>
                <input
                  className="form-control"
                  name="firstName"
                  type="text"
                  ref={register({ required: true })}
                />
                {errors.firstName && "First name is required"}
              </div>
            )}

            {isSignUp && (
              <div className="form-group">
                <label htmlFor="Name">Last name</label>
                <input
                  className="form-control"
                  name="lastName"
                  type="text"
                  ref={register({ required: true })}
                />
                {errors.lastName && "Last name is required"}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                className="form-control"
                name="email"
                type="email"
                ref={register({ required: true })}
              />
              {errors.email && "email is required"}
            </div>
            <div className="form-group">
              <label htmlFor="Name">password</label>
              <input
                className="form-control"
                name="password1"
                type="password"
                ref={register({ required: true })}
              />
              {errors.password && "password is required"}
            </div>

            {isSignUp && (
              <div className="form-group">
                <label htmlFor="Name">password</label>
                <input
                  className="form-control"
                  name="password2"
                  type="password"
                  ref={register({ required: true })}
                />
                {errors.password && "password is required"}
              </div>
            )}

            <Button
              lg="true"
              block
              color="warning"
              onClick={hadleSignInAndSignUp}
              type="submit"
            >
              {isSignUp ? <span>Sign up</span> : <span>Sign in</span>}
            </Button>
            {isSignUp ? (
              <>
                <span>Don't have an account? </span>
                <span
                  onClick={() => setSignUp(false)}
                  style={{ color: "orange", cursor: "pointer" }}
                >
                  Login
                </span>
              </>
            ) : (
              <>
                <span>Already have an account? </span>
                <span
                  onClick={() => setSignUp(true)}
                  style={{ color: "orange", cursor: "pointer" }}
                >
                  SignUp
                </span>
              </>
            )}
          </form>
        </Col>
      </Row>
      <Row className=" my-5">
        <Col>
          <button className="my-5" onClick={googleSignInHandle}>
            Continue with google
          </button>{" "}
          <br />
          <Link to="/">Home</Link>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
